module.exports = __webpack_public_path__ + "onboarding-process.534cf1705830b43482328f59e313aa02.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/projects/empty/onboarding-process.svg
// module id = 1185403194312734
// module chunks = 1